import { BillingAdvisorProPlanUsageObject } from '@/modules/billing/models/BillingAdvisorProPlanUsageObject';
import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { StripePaymentMethod } from '@/modules/billing/models/stripe/StripePaymentMethod';
import { StripeBillingPortalSession } from '@/modules/billing/models/stripe/StripeBillingPortalSession';
import { StripeInvoice } from '@/modules/billing/models/stripe/StripeInvoice';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { PlatformProduct } from '@/modules/platformproduct/models/PlatformProduct';
export class BillingAdvisorProResource extends BaseResource {
  async getActivePlan(): Promise<BillingAdvisorProPlanUsageObject> {
    return this.getData(Route.BILLINGS_ADVISOR_ACTIVE_PLAN, BillingAdvisorProPlanUsageObject);
  }

  async getNextPlan(): Promise<BillingAdvisorProPlanUsageObject> {
    return this.getData(Route.BILLINGS_ADVISOR_NEXT_PLAN, BillingAdvisorProPlanUsageObject);
  }

  async getPaymentMethod(): Promise<StripePaymentMethod> {
    return this.getData(Route.BILLINGS_ADVISOR_PAYMENTMETHOD, StripePaymentMethod);
  }

  async createPaymentMethodPortalSession(returnUrl: string): Promise<StripeBillingPortalSession> {
    return this.postData(Route.BILLINGS_ADVISOR_CREATEPAYMENTMETHODPORTALSESSION, {
      returnUrl
    });
  }

  async setSubscriptionDefaultPaymentMethod(): Promise<void> {
    return this.postData(Route.BILLINGS_ADVISOR_SETSUBSCRIPTIONDEFAULTPAYMENTMETHOD, {});
  }

  async getInvoices(params: Params = {}): Promise<StripeInvoice[]> {
    return this.getData(Route.BILLINGS_ADVISOR_INVOICES, StripeInvoice, params);
  }

  async unCancelPlan(): Promise<void> {
    return this.postData(Route.BILLINGS_ADVISOR_UNCANCELPLAN, {});
  }

  async changePlan(productKey: ProductKey): Promise<PlatformProduct> {
    const platformProduct: PlatformProduct = await this.postData(
      Route.BILLINGS_ADVISOR_CHANGEPLAN,
      { productKey }
    );

    return PlatformProduct.mapModel(platformProduct);
  }
}

export default new BillingAdvisorProResource();
